import "../css/app.scss";

import Navigation from "./components/navigation";
import ScrollImage from "./components/scrollImage";

$(() => {
  const $navigation = $("[data-navigation-panel]");
  if ($navigation.length) {
    new Navigation($navigation);
  }

  $("[data-scroll-image]").each((index, element) => {
    new ScrollImage($(element));
  });
});
